import { useEffect, useState } from 'react';
import { useGameStore } from '../store';

/**
 * Hook that automatically processes expired cards when gameDate changes.
 * Removes cards whose expirationDate is before the current gameDate.
 *
 * @returns {{ expiredCount: number, lastCheck: string | null }}
 */
export function useCardExpiration() {
  const [expiredCount, setExpiredCount] = useState(0);
  const [lastCheck, setLastCheck] = useState(null);

  const gameDate = useGameStore((state) => state.gameDate);
  const processExpiredCards = useGameStore((state) => state.processExpiredCards);

  useEffect(() => {
    const result = processExpiredCards();

    if (result.count > 0) {
      console.log(`[Card Expiration] Removed ${result.count} expired card(s):`, result.expired.map(c => c.name));
      setExpiredCount(result.count);
    }

    setLastCheck(gameDate);
  }, [gameDate, processExpiredCards]);

  return { expiredCount, lastCheck };
}
